import { render, staticRenderFns } from "./former.vue?vue&type=template&id=c7fd78f4&scoped=true&"
import script from "./former.vue?vue&type=script&lang=js&"
export * from "./former.vue?vue&type=script&lang=js&"
import style0 from "./former.vue?vue&type=style&index=0&lang=css&"
import style1 from "./former.vue?vue&type=style&index=1&id=c7fd78f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fd78f4",
  null
  
)

export default component.exports